import graphql__2d9fb170bd1513cced45 from "./__generated__/Comment_comment.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import CommentCard from "./CommentCard";

const Comment = props => {
  const commentsFor = comment => {
    if (comment.comments && comment.comments.edges.length) {
      return (
        <div className="comment-children margin-top-sm">
          {comment.comments.edges.map(commentEdge => (
            <article key={commentEdge.node.id} className="comment-wrapper">
              <CommentCard
                comment={commentEdge.node}
                commentable={commentEdge.node}
                commentableId={commentEdge.node.id}
              />

              {commentsFor(commentEdge.node)}
            </article>
          ))}
        </div>
      );
    }
  };

  return (
    <article className="comment-wrapper">
      <CommentCard
        comment={props.comment}
        commentable={props.comment}
        commentableId={props.comment.id}
      />

      {commentsFor(props.comment)}
    </article>
  );
};

// Load 10 levels of comments. GraphQL doesn't allow for recursive data
// structures to avoid loading too much data, which we don't actually protectect
// here since we don't expect that much comments.
//
// In an enhanced version, we would load data as we scroll and limit initial
// loading to a small subset of the available data.
//
export default createFragmentContainer(Comment, {
  comment: graphql__2d9fb170bd1513cced45
});
